
import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribeStatus, setSubscribeStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubscribe = async (e: FormEvent) => {
    e.preventDefault();
    setSubscribeStatus('idle');

    try {
      const formBody = new URLSearchParams({ email }).toString();
      const response = await fetch('https://readdy.ai/api/form/d6e5cr6qd308q1a0adp0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody
      });

      if (response.ok) {
        setSubscribeStatus('success');
        setEmail('');
      } else {
        setSubscribeStatus('error');
      }
    } catch (error) {
      setSubscribeStatus('error');
    }
  };

  return (
    <footer className="bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12">
          <div className="md:col-span-5">
            <img
              src="https://static.readdy.ai/image/aabcc23d397a531ae9f0b17792c65834/868837240d340ef158720fe61bab18b5.png"
              alt="Auto Transport Logo"
              className="h-14 w-auto mb-4"
            />
            <p className="text-gray-600 text-base mb-4">
              America's Trusted Auto Transport Service
            </p>
            
            <div className="mb-8 space-y-2">
              <a 
                href="tel:3058719862" 
                className="flex items-center text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                (305) 871-9862
              </a>
              <a 
                href="mailto:marcos.disla@shiplux.com" 
                className="flex items-center text-gray-700 hover:text-orange-600 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line mr-2"></i>
                marcos.disla@shiplux.com
              </a>
            </div>

            <div>
              <h4 className="text-gray-900 font-bold text-lg mb-4">
                Get Transport Tips & Deals
              </h4>
              <form onSubmit={handleSubscribe} data-readdy-form id="newsletter-form" className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  required
                  className="flex-1 px-4 py-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-sm"
                />
                <button
                  type="submit"
                  className="bg-orange-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-orange-700 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Subscribe
                </button>
              </form>
              {subscribeStatus === 'success' && (
                <p className="text-green-600 text-sm mt-2">Thanks for subscribing!</p>
              )}
              {subscribeStatus === 'error' && (
                <p className="text-red-600 text-sm mt-2">Please try again.</p>
              )}
              <p className="text-gray-500 text-xs mt-2">
                We respect your privacy. Unsubscribe anytime.
              </p>
            </div>
          </div>

          <div className="md:col-span-7 grid grid-cols-3 gap-8">
            <div>
              <h4 className="font-bold text-gray-900 mb-4">Services</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Open Transport
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Enclosed Transport
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Expedited Shipping
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    International
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-gray-900 mb-4">Company</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    About Us
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    How It Works
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Carriers
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Blog
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-gray-900 mb-4">Support</h4>
              <ul className="space-y-2">
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Contact
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    FAQ
                  </a>
                </li>
                <li>
                  <a href="#" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Track Shipment
                  </a>
                </li>
                <li>
                  <a href="#quote" className="text-gray-600 hover:text-orange-600 transition-colors cursor-pointer">
                    Get Quote
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-gray-900 py-6">
        <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Auto Transport. All rights reserved.
          </p>

          <div className="flex items-center gap-6">
            <Link to="/privacy-policy" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
              Privacy Policy
            </Link>
            <span className="text-gray-600">|</span>
            <Link to="/terms-of-service" className="text-gray-400 text-sm hover:text-white transition-colors cursor-pointer">
              Terms of Service
            </Link>
          </div>

          <div className="flex items-center gap-4">
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-facebook-fill text-xl"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-twitter-x-line text-xl"></i>
            </a>
            <a
              href="#"
              className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-white transition-colors cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
          </div>
        </div>
        
        <div className="max-w-7xl mx-auto px-6 mt-4 text-center">
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-gray-500 text-xs hover:text-gray-300 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
